<script setup>
import { formatBytes } from 'shared/helpers/FileHelper';

defineProps({
  attachments: {
    type: Array,
    default: () => [],
  },
});

const formatFileSize = byteSize => {
  if (!byteSize) return '';
  return formatBytes(byteSize, 0);
};
</script>

<template>
  <div>
    <template v-if="attachments && attachments.length > 0">
      <div class="mt-2 space-y-2">
        <div
          v-for="attachment in attachments"
          :key="attachment.id"
          class="flex items-center gap-2 p-2 bg-n-solid-2 rounded-lg border border-n-weak"
        >
          <div class="flex-shrink-0">
            <span
              v-if="attachment.content_type?.includes('image')"
              class="i-lucide-image w-5 h-5 text-n-slate-11"
            />
            <span v-else class="i-lucide-file w-5 h-5 text-n-slate-11" />
          </div>
          <div class="flex-1 min-w-0">
            <div class="text-sm font-medium text-n-slate-12 truncate">
              {{ attachment.filename }}
            </div>
            <div v-if="attachment.byte_size" class="text-xs text-n-slate-11">
              {{ formatFileSize(attachment.byte_size) }}
            </div>
          </div>
          <a
            :href="attachment.url"
            target="_blank"
            rel="noopener noreferrer"
            class="flex-shrink-0 p-1 hover:bg-n-solid-3 rounded transition-colors"
            :title="$t('CONVERSATION.DOWNLOAD')"
          >
            <span class="i-lucide-download w-4 h-4 text-n-slate-11" />
          </a>
        </div>
      </div>
    </template>
  </div>
</template>
